import React from "react";
import { useModalStore } from "@/hooks/useModalStore";
import { Button, Modal } from "antd";
import { CloseIcon, NavbarLogoIcon } from "../icons";
import { useTranslation } from "react-i18next";

export default function AffiliateNoRechargeModal() {
  const { t } = useTranslation();
  const { showAffiliateNoRechargeModal, setShowAffiliateNoRechargeModal } =
    useModalStore();

  return (
    <Modal
      open={showAffiliateNoRechargeModal}
      width={560}
      footer={null}
      title=""
      styles={{
        content: {
          padding: 0,
          borderRadius: "24px",
        },
      }}
      closable={false}
    >
      <div className="pt-8 px-[72px] pb-[28px] w-full relative">
        <div
          className="absolute top-8 right-10 cursor-pointer"
          onClick={() => setShowAffiliateNoRechargeModal(false)}
        >
          <CloseIcon className="text-gray-500 text-lg" />
        </div>
        <div className="w-full flex justify-center items-center mt-6">
          <NavbarLogoIcon className="w-10 h-10" />
        </div>
        <div className="self-stretch inline-flex flex-col justify-start items-start gap-4  mt-10">
          <div className="self-stretch inline-flex justify-between items-start">
            <div className="flex-1 flex justify-start items-center gap-2.5">
              <div className="flex-1 justify-start text-text-color-primary text-xl font-bold font-['DM_Sans'] leading-loose">
                {t('components.affiliateNoRechargeModal.dearUser')}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            <div className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-relaxed">
              {t('components.affiliateNoRechargeModal.strategicAdjustment')}
            </div>
            <div className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-relaxed">
              {t('components.affiliateNoRechargeModal.changeNotAffect')}
            </div>
            <div className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-relaxed">
              {t('components.affiliateNoRechargeModal.contactForQuestions')}
            </div>
            <div className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-relaxed">
              <span className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-relaxed">
                {t('components.affiliateNoRechargeModal.email')}
              </span>
              <a
                href="mailto:support@aha.inc"
                className="text-[#2B7FFF] text-sm font-medium  leading-snug"
              >
                support@aha.inc
              </a>
            </div>
            <div className="text-font&icon-primary text-sm font-normal font-['DM_Sans'] leading-relaxed">
              {t('components.affiliateNoRechargeModal.appreciation')}
            </div>
          </div>
        </div>
        <Button
          className="black-button mt-6 w-full"
          size="large"
          onClick={() => setShowAffiliateNoRechargeModal(false)}
        >
          {t('components.affiliateNoRechargeModal.gotIt')}
        </Button>
      </div>
    </Modal>
  );
}
